const key = 'mobileUserInfo'

export function getUserInfo() {
  return localStorage.getItem(key)
}

export function setUserInfo(info) {
  return localStorage.setItem(key, info)
}

export function removeUserInfo() {
  return localStorage.removeItem(key)
}
